import { Settings } from 'luxon'
import { DateTime } from 'luxon-business-days'

interface DatePayload {
  day: number
  month: number
  year: number
}

export function usePluginLuxon(): void {
  Settings.defaultLocale = 'sv'
  Settings.defaultZone = 'Europe/Stockholm'

  const dt = DateTime.local()
  const { availableHolidayMatchers } = dt

  dt.setupBusiness({
    holidayMatchers: [
      availableHolidayMatchers.isNewYearsDay,
      availableHolidayMatchers.isEasterDay,
      isThirteenDaysAfterChristmas,
      isFirstOfMay,
      isNationalDay,
      availableHolidayMatchers.isChristmasDay,
    ],
  })
}

function isThirteenDaysAfterChristmas(current: DatePayload): boolean {
  const matchesMonth = current.month === 1
  const matchesDay = current.day === 6

  return matchesMonth && matchesDay
}

function isFirstOfMay(current: DatePayload): boolean {
  const matchesMonth = current.month === 5
  const matchesDay = current.day === 1

  return matchesMonth && matchesDay
}

function isNationalDay(current: DatePayload): boolean {
  const matchesMonth = current.month === 6
  const matchesDay = current.day === 6

  return matchesMonth && matchesDay
}
